import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-gray-600" }
const _hoisted_2 = { class: "max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "flex items-center space-x-3 rtl:space-x-reverse"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/spec_logo.png",
    class: "h-24"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "self-center text-2xl font-semibold whitespace-nowrap" }, "Spec")
], -1)
const _hoisted_4 = {
  class: "relative",
  ref: "dropdown"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "absolute right-2 top-1/2 transform -translate-y-1/2",
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_6 = {
  key: 0,
  class: "absolute w-full mt-1 bg-white border border-gray-400 shadow-lg z-10",
  ref: "dropdownMenu"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "text-white bg-blue-500 hover:bg-blue-600 focus:bg-blue-700 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    class: "w-6 h-6"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args))),
          class: _normalizeClass(["font-semibold text-lg p-1 rounded-lg pr-10 hover:bg-gray-500 focus:bg-gray-500", { 'text-gray-300': _ctx.showDropdown }])
        }, " Mina Specialiseringar ", 2),
        _hoisted_5,
        (_ctx.showDropdown)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dropDownData, (specialization) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: specialization.program.programmeCode,
                  class: "px-4 py-2 flex items-center dropdown-item",
                  onClick: ($event: any) => (_ctx.selectItem(specialization))
                }, _toDisplayString(specialization.program.programmeCode +
              " - " +
              specialization.spec?.specialisation_sv), 9, _hoisted_7))
              }), 128))
            ], 512))
          : _createCommentVNode("", true)
      ], 512),
      _hoisted_8
    ])
  ]))
}